import React, { useEffect, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  IconButton,
  Tooltip,
  TableCell,
  Checkbox,
  TableRow,
  Table,
  TableBody,
  TableHead,
  Paper,
  TablePagination,
  TableContainer,
  Autocomplete,
} from "@mui/material";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import {
  LOCATION_API_01,
  MAPLOCATION_API_01,
  PAYMENT_API_01,
  PAYMENT_API_03,
  PAYMENT_API_04,
  TAX_API_03,
  TAX_API_05,
} from "../../api/ApiModel";
import { CheckBox } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
function MapPayments() {
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedRows, setSelectedRows] = useState([]); // To track selected rows
  const [data, setData] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedLOC, setSelectedLOC] = useState("");
  const [data1, setData1] = useState([]);
  const [data3, setData3] = useState([]);
  const [dataloc, setDataloc] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [rows1, setRows1] = useState([]);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, RESTCODE, USERREFCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    // GROUPCODE: "",
    // GROUPNAME: "",
  });

  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const gotToPage = () => {
    navigate("/ViewLocations");
  };

  const fetchData = async () => {
    try {
      const result = await externalgetApi(TAX_API_03, "get");
      setData1(result);
    } catch (err) {
      setError(err);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Fetching data from API...");

        // Fetch data from the API
        const result = await externalgetApi(PAYMENT_API_01, "get");

        // Process result if needed
        const processedData = result.map((item) => ({
          ...item,
          decodedIcon: atob(item.ICONFILE), // Decode base64 string if needed
        }));

        setData(processedData);
        setFilteredRows(processedData);

        console.log("Data fetched successfully:", processedData);
      } catch (err) {
        console.error("Error fetching payment data:", err.message || err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleClearClick = () => {
    //clear text filed function goes here
    alert("add Clear button click event");
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      //   onClick: (GROUPCODE) => handleItemClick(GROUPCODE, "Edit"),
    },
  ];

  const handleSelectionChange = (event, value) => {
    setSelectedValue(value);
    console.log("Selected value:", value);
    // Pass the selected value to any required function here
  };
  const handleSelectionloc = (newvalue) => {
    setSelectedLOC(newvalue);
    console.log("Selected value:", newvalue);
    // Pass the selected value to any required function here
  };

  const handleSelectRow = (paymentCode) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(paymentCode)
        ? prevSelected.filter((code) => code !== paymentCode)
        : [...prevSelected, paymentCode]
    );
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value); // Update searchText when typing in TextField
  };

  useEffect(() => {
    fetchDatapay();
  }, [selectedValue, selectedLOC]); // Refetch data when selectedValue changes

  const fetchDatapay = async () => {
    if (!selectedValue || !selectedLOC) {
      console.log("No selectedValue or selectedLOC, skipping API call.");
      return; // Skip fetch if selectedValue or selectedLOC is null or undefined
    }

    setIsLoading(true);
    try {
      const result = await externalgetApi(PAYMENT_API_04, "get", {
        COMPCODE,
        // LOCCODE: "MRTMCLC0059",
        LOCCODE: selectedLOC.LOCCODE,
        PAGECODE: selectedValue.TAXPAGECODE || "", // Use selectedValue dynamically
      });
      setData3(result || []); // Ensure result is an array
      console.log("Fetched data for TAXPAGECODE:", result);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(`Failed to load options: ${err.message || err}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirm = async () => {
    // Check if PAGECODE is empty
    if (
      !selectedValue.TAXPAGECODE ||
      selectedValue.TAXPAGECODE.trim() === "" ||
      !selectedLOC.LOCCODE
    ) {
      setSnackbarMessage("Select the Location payment option.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      setSnackbarOpen(true);
      return; // Stop execution if PAGECODE is empty
    }

    const payload = {
      mappayemntsDt: selectedRows.map((paymentCode) => ({
        paymentcode: paymentCode,
        sts: CON_STATUS_ACTIVE,
      })),
      PAGECODE: selectedValue.TAXPAGECODE,
      COMPCODE,
      LOCCODE: selectedLOC.LOCCODE,
      lOCDATE: new Date().toISOString().split("T")[0],
      ENUSER: USERNAME,
    };

    console.log("Payload for API call:", payload);

    try {
      const response = await externalpostApi(PAYMENT_API_03, payload);
      console.log("Success:", response.data);
      fetchDatapay();
      setSelectedRows([]);

      setSnackbarMessage("Payment Updated Successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to submit payments.");
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const [page, setPage] = useState(0); // Current page number
  const [rowsPerPage, setRowsPerPage] = useState(10); // Number of rows per page

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(MAPLOCATION_API_01, "get", {
          COMPCODE,
          USERREFCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Ensure fetching only items where STS is 'A'
        });

        setDataloc(result); // Set the filtered data into the state
        console.log("fil", result);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Payments</Link>
                <Link underline="none">Map Payments</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.box_container_add}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={styles.col_title}
              display={"flex"}
              width={"100%"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography variant="title" align="left">
                Map Payments
              </Typography>

              <Box
                sx={{
                  width: {
                    xs: "50%",
                    sm: "50%",
                    md: "20%",
                    lg: "20%",
                    xl: "20%",
                  },
                }}
              >
                <Autocomplete
                  options={Array.isArray(dataloc) ? dataloc : []}
                  getOptionLabel={(option) => option.LOCATION || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location"
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                  onChange={(event, newValue) => {
                    handleSelectionloc(newValue); // Ensure this updates the state correctly
                  }}
                  value={
                    Array.isArray(dataloc) && selectedLOC
                      ? dataloc.find(
                          (item) => item.LOCCODE === selectedLOC.LOCCODE
                        ) || null
                      : null
                  }
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                  loading={isLoading}
                />
              </Box>
              {/* </Stack> */}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box p={1} sx={styles.AddStyledBoxpay}>
              <Grid item xs={12} sm={12} md={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box
                      sx={styles.col_title}
                      display={"flex"}
                      width={"100%"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Typography variant="title" align="left">
                        Payment Options for
                      </Typography>

                      <Box width={"50%"}>
                        <Autocomplete
                          options={Array.isArray(data1) ? data1 : []}
                          getOptionLabel={(option) => option.TAXPAGENAME || ""}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Payment Options for"
                              size="small"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                          onChange={handleSelectionChange}
                          value={
                            selectedValue ||
                            (Array.isArray(data1)
                              ? data.find(
                                  (item) =>
                                    item.TAXPAGECODE ===
                                    selectedValue?.TAXPAGECODE
                                ) || null
                              : null)
                          }
                          ListboxProps={{
                            style: {
                              maxHeight: 150,
                              backgroundColor: theme.palette.background.paper,
                            },
                          }}
                          noOptionsText={
                            <div
                              style={{
                                backgroundColor:
                                  "theme.palette.background.paper",
                                padding: "8px",
                              }}
                            >
                              No options
                            </div>
                          }
                          loading={isLoading}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <TableContainer sx={{ ...styles.VI_ViewStyledPaperpay, mt: 1 }}>
                {isLoading ? (
                  <CircularProgress
                    style={{ margin: "20px auto", display: "block" }}
                  />
                ) : (
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        {/* <TableCell>Payment Code</TableCell> */}
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            // background: theme.palette.background.paper,
                          }}
                          align="center"
                        >
                          Icon
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            // background: theme.palette.background.paper,
                          }}
                        >
                          Payment Mode
                        </TableCell>

                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            // background: theme.palette.background.paper,
                          }}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            // background: theme.palette.background.paper,
                          }}
                        >
                          Payment status
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            // background: theme.palette.background.paper,
                          }}
                        >
                          Select
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredRows.map((row, index) => (
                        <TableRow key={row.PAYMENTCODE}>
                          <TableCell
                            padding="none"
                            sx={{
                              display: "none", // Hides the cell for all screen sizes
                            }}
                          >
                            {row.PAYMENTCODE}
                          </TableCell>
                          <TableCell padding="none" align="center">
                            <img
                              src={`data:image/png;base64,${row.ICONFILE}`}
                              alt="Icon"
                              style={{ width: 32, height: 32 }}
                            />
                          </TableCell>
                          <TableCell padding="none">
                            {row.PAYMENTMODE}
                          </TableCell>

                          <TableCell align="center">{row.STS}</TableCell>
                          <TableCell align="center">
                            {row.PAYMENTSTATUS}
                          </TableCell>

                          <TableCell align="center" padding="none">
                            <Checkbox
                              padding="none"
                              checked={selectedRows.includes(row.PAYMENTCODE)}
                              onChange={() => handleSelectRow(row.PAYMENTCODE)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 50, 100, 500, 1000]}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={(props) => (
                  <Stack direction="row" spacing={2} alignItems="center">
                    {/* Default pagination actions */}
                    <div {...props} />

                    {/* Custom button */}
                    <Button
                      sx={{
                        background: theme.palette.primary.main,
                        color: theme.palette.text.buttontxt,
                        textTransform: "capitalize",
                        width: "120px",
                      }}
                      variant="contained"
                      color="primary"
                      onClick={handleConfirm}
                    >
                      Confirm
                    </Button>
                  </Stack>
                )}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <Box p={1} sx={styles.st_page_table}>
              <TableContainer component={Paper}>
                <Table stickyHeader aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold" }} align="left">
                        Payment
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="center">
                        Payment Status
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="center">
                        Status
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading ? (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    ) : error ? (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          Error: {error}
                        </TableCell>
                      </TableRow>
                    ) : data3.length > 0 ? (
                      data3.map((row) => (
                        <TableRow key={row.PAYMENTCODE}>
                          <TableCell align="Left">{row.PAYMENTMODE}</TableCell>
                          <TableCell align="center">
                            {row.PAYMENTSTATUS}
                          </TableCell>
                          <TableCell align="center">{row.STS}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center"></TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </div>
  );
}

export default MapPayments;
